import { render, staticRenderFns } from "./BatchRemittancePayeeNotAccount.vue?vue&type=template&id=b34667c4&scoped=true&"
import script from "./BatchRemittancePayeeNotAccount.vue?vue&type=script&lang=js&"
export * from "./BatchRemittancePayeeNotAccount.vue?vue&type=script&lang=js&"
import style0 from "./BatchRemittancePayeeNotAccount.vue?vue&type=style&index=0&id=b34667c4&lang=less&scoped=true&"
import style1 from "./BatchRemittancePayeeNotAccount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34667c4",
  null
  
)

export default component.exports